export interface DataStoreStateModel {
  datesList: string[];
}

export class DataStorePatch {
  static readonly type = '@dataStore.patchStore';
  constructor(public state: Partial<DataStoreStateModel>) {}
}
